import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * CardsShowcase Component
 * Displays card component with theme styling
 */
const CardsShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography variant="subtitle2" gutterBottom>
        Cards
      </Typography>
      <Card sx={{ backgroundColor: theme.surface_color }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{
              color: theme.primary_color,
              fontFamily: theme.font_family,
              mb: 1,
            }}
          >
            Card Title
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: theme.text_color,
              fontFamily: theme.font_family,
              fontSize: theme.font_size,
            }}
          >
            This is a sample card component with your theme colors and
            typography.
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

CardsShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default CardsShowcase;
